<div class= "Container">
    <div class= "Container-title">
        <h1>{{error}}</h1>
    </div>
    <div class = "Container-button">
        <button (click)="close()">OK</button>
    </div>
</div>